import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../../ui/Dialog/DialogActions";
import Checkbox from "@material-ui/core/Checkbox";
import ManageEmployeeForm from "./ManageEmployeeForm";
import Button from "../../../../../../../../ui/Button";

const styles = theme => ({
    dialog: {
        width: "550px"
    }
});

const ManageEmployee = ({
    open,
    handleClose,
    updateEmployee,
    employee,
    orgId,
    classes
}) => {
    const [formData, updateFormData] = React.useState(null);

    const onConfirm = () => {
        updateEmployee(orgId, employee.id, formData);
        handleClose();
    };

    const onClose = () => {
        updateFormData(null);
        handleClose();
    };

    return (
        <div>
            <Dialog
                onClose={onClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                PaperProps={{
                    className: classes.dialog
                }}
            >
                <DialogTitle onClose={onClose}>
                    Изменить должность / Уволить
                </DialogTitle>
                <DialogContent>
                    <ManageEmployeeForm
                        orgId={orgId}
                        employee={employee}
                        onFormChange={updateFormData}
                    />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Отмена</Button>
                  <Button onClick={() => onConfirm()} color="green">
                      Сохранить
                  </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default withStyles(styles)(withRouter(ManageEmployee));
